import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { Button } from "@material-ui/core";
import Spacer from "../../../components/Spacer";
import MainContainer from "../../../components/MainContainer";
import { headerDataSettings } from "../../../data/modules/settings-header";
import { useParams } from "react-router-dom";
import Message from "../../tools/Message";
import CategoryMissionService from "../../../services/CategoryMissionService";
import { useNavigate } from "react-router-dom";
import PlanningMissionService from "../../../services/PlanningMissionService";
import Autocomplete from "@material-ui/lab/Autocomplete";

import {
  FormControl,
  Select,
  MenuItem,
  InputLabel,
} from "@material-ui/core";
import LoadingSimpleBackdrop from "../../tools/LoadingSimpleBackdrop";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "row",
    maxWidth: 800,
    elevation: 0,
  },
  form: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  chips: {
    display: "flex",
    flexWrap: "wrap",
  },
  chip: {
    margin: 2,
  },
  labelPosition: {
    float: "left",
  },
  text: {
    width: 370,
  },
}));

function normalizeText(value) {
  return (value || "")
    .toString()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim()
    .toLowerCase();
}

function mapTypeToCode(typeValue) {
  const normalizedType = normalizeText(typeValue);

  if (normalizedType === "avant" || normalizedType.includes("avant")) {
    return "avant";
  }
  if (normalizedType === "apres" || normalizedType.includes("apres")) {
    return "apres";
  }
  if (normalizedType === "logistique") {
    return "logistique";
  }
  if (normalizedType === "comptable") {
    return "comptable";
  }

  return "au moment";
}

function matchUserName(user, names) {
  const firstLast = normalizeText(`${user.first_name || ""} ${user.last_name || ""}`);
  const lastFirst = normalizeText(`${user.last_name || ""} ${user.first_name || ""}`);

  return names.some((name) => {
    const normalizedName = normalizeText(name);
    return normalizedName === firstLast || normalizedName === lastFirst;
  });
}

function CopieMailAdd() {
  const classes = useStyles();
  const { id: copie_mail_id } = useParams();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    type: "",
    user_id: [],
    dir: null,
    diru: null,
    servu: null,
    action: "add",
  });

  const [direction, setDirection] = useState([]);
  const [directionu, setDirectionu] = useState([]);
  const [dirdetailu, setDirDetailsu] = useState(null);
  const [serviceu, setServiceu] = useState([]);
  const [service_idu, setService_idu] = useState(null);

  const [dirdetail, setDirDetails] = useState(null);
  const [service, setService] = useState([]);
  const [service_id, setService_id] = useState([]);
  const [utilisateur, setUtilisateur] = useState([]);
  const [copieNames, setCopieNames] = useState([]);
  const [shouldHydrateUsers, setShouldHydrateUsers] = useState(false);

  const [openLoadingSimpleBackdrop, setOpenLoadingSimpleBackdrop] = useState(false);
  const [message, setMessage] = useState({
    open: false,
    color: "green",
    messageInfo: "",
  });
  const { open, color, messageInfo } = message;

  function handleChangeDirdestination(event, value) {
    setDirDetails(value || null);
    setService([]);
    setService_id([]);
    setUtilisateur([]);
    setCopieNames([]);
    setShouldHydrateUsers(false);
    setForm((prev) => ({ ...prev, dir: value || null, user_id: [] }));

    if (!value || !value.direction_id) {
      return;
    }

    const directionId = parseInt(value.direction_id, 10);
    if (Number.isNaN(directionId)) {
      return;
    }

    PlanningMissionService.getService([directionId]).then((result) => {
      if (result && result.data) {
        setService(result.data);
      }
    });
  }

  function handleChangeDirdestinationu(event, value) {
    setDirDetailsu(value || null);
    setServiceu([]);
    setService_idu(null);
    setForm((prev) => ({ ...prev, diru: value || null, servu: null }));

    if (!value || !value.direction_id) {
      return;
    }

    const directionId = parseInt(value.direction_id, 10);
    if (Number.isNaN(directionId)) {
      return;
    }

    PlanningMissionService.getService([directionId]).then((result) => {
      if (result && result.data) {
        setServiceu(result.data);
      }
    });
  }

  function handleChangeService(event, value) {
    const selectedServices = Array.isArray(value) ? value : [];
    setService_id(selectedServices);
    setForm((prev) => ({ ...prev, user_id: [] }));
  }

  function handleChangeServiceu(event, value) {
    setService_idu(value || null);
    setForm((prev) => ({ ...prev, servu: value || null }));
  }

  useEffect(() => {
    let isMounted = true;

    const loadInitialData = async () => {
      setOpenLoadingSimpleBackdrop(true);
      try {
        const directionResult = await PlanningMissionService.getDirection();
        const directions = directionResult && directionResult.data ? directionResult.data : [];

        if (!isMounted) {
          return;
        }

        setDirection(directions);
        setDirectionu(directions);

        if (!copie_mail_id) {
          return;
        }

        const copieResult = await CategoryMissionService.getcopieByID(copie_mail_id);
        const copieData = copieResult && copieResult.data ? copieResult.data : null;

        if (!copieData || !isMounted) {
          return;
        }

        const selectedMissionDirection =
          directions.find(
            (item) => normalizeText(item.name) === normalizeText(copieData.direction_miss)
          ) || null;
        const selectedCopyDirection =
          directions.find(
            (item) => normalizeText(item.name) === normalizeText(copieData.direction_copie)
          ) || null;

        const directionIds = [];
        if (selectedMissionDirection && selectedMissionDirection.direction_id) {
          directionIds.push(parseInt(selectedMissionDirection.direction_id, 10));
        }
        if (selectedCopyDirection && selectedCopyDirection.direction_id) {
          const copyDirectionId = parseInt(selectedCopyDirection.direction_id, 10);
          if (!directionIds.includes(copyDirectionId)) {
            directionIds.push(copyDirectionId);
          }
        }

        let allServices = [];
        if (directionIds.length > 0) {
          const serviceResult = await PlanningMissionService.getService(directionIds);
          allServices = serviceResult && serviceResult.data ? serviceResult.data : [];
        }

        const missionServices = selectedMissionDirection
          ? allServices.filter(
              (item) =>
                parseInt(item.direction_id, 10) ===
                parseInt(selectedMissionDirection.direction_id, 10)
            )
          : [];
        const copyServices = selectedCopyDirection
          ? allServices.filter(
              (item) =>
                parseInt(item.direction_id, 10) ===
                parseInt(selectedCopyDirection.direction_id, 10)
            )
          : [];

        const selectedServiceMission = missionServices.find(
          (item) => normalizeText(item.name) === normalizeText(copieData.service_miss)
        ) || null;

        const copiedUsers = Array.isArray(copieData.copie)
          ? copieData.copie.map((item) => item.name)
          : [];

        if (!isMounted) {
          return;
        }

        setDirDetails(selectedCopyDirection);
        setDirDetailsu(selectedMissionDirection);
        setService(copyServices);
        setServiceu(missionServices);
        setService_id([]);
        setService_idu(selectedServiceMission);
        setCopieNames(copiedUsers);
        setShouldHydrateUsers(copiedUsers.length > 0);
        setForm((prev) => ({
          ...prev,
          type: mapTypeToCode(copieData.type),
          dir: selectedCopyDirection,
          diru: selectedMissionDirection,
          servu: selectedServiceMission,
          user_id: [],
          action: "edit",
        }));
      } finally {
        if (isMounted) {
          setOpenLoadingSimpleBackdrop(false);
        }
      }
    };

    loadInitialData();

    return () => {
      isMounted = false;
    };
  }, [copie_mail_id]);

  useEffect(() => {
    if (!dirdetail || !dirdetail.direction_id) {
      setUtilisateur([]);
      return;
    }

    const directionIds = [parseInt(dirdetail.direction_id, 10)];
    let serviceIds = Array.isArray(service_id)
      ? service_id
          .map((item) => parseInt(item.service_id, 10))
          .filter((value) => !Number.isNaN(value))
      : [];

    if (serviceIds.length === 0 && shouldHydrateUsers && Array.isArray(service) && service.length > 0) {
      serviceIds = service
        .map((item) => parseInt(item.service_id, 10))
        .filter((value) => !Number.isNaN(value));
    }

    PlanningMissionService.getIntervenant(directionIds, serviceIds).then((result) => {
      const users = result && result.data ? result.data : [];
      setUtilisateur(users);

      if (shouldHydrateUsers) {
        const selectedUsers = users.filter((user) => matchUserName(user, copieNames));
        setForm((prev) => ({ ...prev, user_id: selectedUsers }));
        setShouldHydrateUsers(false);
      }
    });
  }, [dirdetail, service_id, shouldHydrateUsers, copieNames, service]);

  function handleClick() {
    const directionCopieId = form.diru && form.diru.direction_id ? form.diru.direction_id : null;
    const directionMissionId = form.dir && form.dir.direction_id ? form.dir.direction_id : null;
    const serviceMissionId =
      (service_idu && service_idu.service_id) || (form.servu && form.servu.service_id) || null;
    if(copie_mail_id){
      CategoryMissionService.updatecopie(
        copie_mail_id,
        form.type,
        directionCopieId,
        service_id,
        directionMissionId,
        serviceMissionId,
        form.user_id
      ).then((result) => {
        if (result.status) {
          setMessage({ ...message, open: true, color: "green", messageInfo: "Succes" });
          navigate("/mission_mail");
        } else {
          setMessage({ ...message, open: true, color: "red", messageInfo: "Erreur" });
        }
      });
      return;
    }
    
    CategoryMissionService.insertcopie(
      form.type,
      directionCopieId,
      service_id,
      directionMissionId,
      serviceMissionId,
      form.user_id
    ).then((result) => {
      if (result.status) {
        setMessage({ ...message, open: true, color: "green", messageInfo: "Succes" });
        navigate("/mission_mail");
      } else {
        setMessage({ ...message, open: true, color: "red", messageInfo: "Erreur" });
      }
    });
  }

  function handleChange(event) {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  }

  function handleChangeIntervenants(event, value) {
    const selectedUsers = Array.isArray(value) ? value : [];
    setForm((prev) => ({ ...prev, user_id: selectedUsers }));
  }

  function handleCloseMessage() {
    setMessage({ ...message, open: false });
  }

  return (
    <MainContainer {...headerDataSettings}>
      <LoadingSimpleBackdrop openLoadingSimpleBackdrop={openLoadingSimpleBackdrop} />
      <Message open={open} color={color} messageInfo={messageInfo} handleClose={handleCloseMessage} />
      <Grid container item xs={12}>
        <Button
          variant="contained"
          color="secondary"
          onClick={() => navigate("/mission_mail")}
          style={{ fontWeight: 600, marginLeft: 10, marginRight: 10 }}
        >
          ANNULER
        </Button>
        <Button variant="contained" color="primary" onClick={handleClick} style={{ fontWeight: 600 }}>
          ENREGISTRER
        </Button>
      </Grid>
      <Spacer y={2} />
      <Paper className={classes.paper} variant="outlined">
        <Grid container spacing={3}>
          <Grid item xs={2}>
            <label className={classes.labelPosition}>Type de l'envoie *</label>
          </Grid>
          <Grid item xs={10}>
            <FormControl fullWidth variant="outlined" size="small">
              <InputLabel id="demo-simple-select-outlined-label">Type de l'envoie</InputLabel>
              <Select
                labelId="demo-simple-select-outlined-label"
                id="demo-simple-select-outlined"
                label="Type de l'envoie"
                value={form.type}
                name="type"
                onChange={handleChange}
              >
                <MenuItem value="avant">Avant la validation finale</MenuItem>
                <MenuItem value="apres">Apres la validation finale</MenuItem>
                <MenuItem value="au moment">Au moment de l'envoi pour validation</MenuItem>
                <MenuItem value="logistique">Logistique</MenuItem>
                <MenuItem value="comptable">Comptable</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={2}>
            <label className={classes.labelPosition}>Direction des missionaires *</label>
          </Grid>
          <Grid item xs={10}>
            <Autocomplete
              onChange={handleChangeDirdestinationu}
              value={dirdetailu || null}
              name="directionu"
              options={directionu}
              getOptionLabel={(option) =>
                option && option.name ? `${option.name} (${option.code})` : ""
              }
              getOptionSelected={(option, value) =>
                Boolean(value) && option.direction_id === value.direction_id
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  size="small"
                  variant="outlined"
                  InputProps={{ ...params.InputProps, type: "search" }}
                />
              )}
            />
          </Grid>
          <Grid item xs={2}>
            <label>Service des missionaires </label>
          </Grid>
          <Grid item xs={10}>
            <Autocomplete
              fullWidth
              onChange={handleChangeServiceu}
              value={service_idu || null}
              options={serviceu}
              getOptionLabel={(option) =>
                option && option.name ? `${option.name} (${option.code})` : ""
              }
              getOptionSelected={(option, value) =>
                Boolean(value) && option.service_id === value.service_id
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  label="Service"
                  size="small"
                  variant="outlined"
                  InputProps={{ ...params.InputProps, type: "search" }}
                />
              )}
            />
          </Grid>
          <Grid item xs={2}>
            <label className={classes.labelPosition}>Direction en copie *</label>
          </Grid>
          <Grid item xs={10}>
            <Autocomplete
              onChange={handleChangeDirdestination}
              value={dirdetail || null}
              name="direction"
              options={direction}
              getOptionLabel={(option) =>
                option && option.name ? `${option.name} (${option.code})` : ""
              }
              getOptionSelected={(option, value) =>
                Boolean(value) && option.direction_id === value.direction_id
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  size="small"
                  variant="outlined"
                  InputProps={{ ...params.InputProps, type: "search" }}
                />
              )}
            />
          </Grid>
          <Grid item xs={2}>
            <label>Service en copie * </label>
          </Grid>
          <Grid item xs={10}>
            <Autocomplete
              fullWidth
              multiple
              onChange={handleChangeService}
              value={service_id || []}
              options={service}
              getOptionLabel={(option) =>
                option && option.name ? `${option.name} (${option.code})` : ""
              }
              getOptionSelected={(option, value) =>
                Boolean(value) && option.service_id === value.service_id
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  label="Service"
                  size="small"
                  variant="outlined"
                  InputProps={{ ...params.InputProps, type: "search" }}
                />
              )}
            />
          </Grid>
          <Grid item xs={2}>
            <label className={classes.labelPosition}>Uilisateurs en copie *</label>
          </Grid>
          <Grid item xs={10}>
            <Autocomplete
              multiple
              id="tags-outlined"
              options={utilisateur}
              value={form.user_id}
              getOptionLabel={(option) =>
                `${option.first_name || ""} ${option.last_name || ""}`.trim()
              }
              getOptionSelected={(option, value) =>
                Boolean(value) && option.user_id === value.user_id
              }
              filterSelectedOptions
              onChange={handleChangeIntervenants}
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  id="outlined-basic"
                  size="small"
                  label="Utilisateurs"
                  variant="outlined"
                  placeholder="Utilisateurs"
                />
              )}
            />
          </Grid>
        </Grid>
      </Paper>
    </MainContainer>
  );
}

export default CopieMailAdd;
